var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.61,
    height: 26.297,
    viewBox: "0 0 22.61 26.297",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5235.839 -687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5255.93,713.3h-17.566c-.022-.012-.043-.033-.066-.036a2.915,2.915,0,0,1-2.459-3.01c.029-2.961.008-5.922.008-8.883q0-5.7,0-11.4a2.8,2.8,0,0,1,1.489-2.6,6.229,6.229,0,0,1,1.027-.37h14.125a2.844,2.844,0,0,1,.416.286q2.635,2.574,5.261,5.158a.9.9,0,0,1,.284.688c-.007.607,0,1.215,0,1.822q0,7.688,0,15.376a2.873,2.873,0,0,1-2.224,2.891C5256.125,713.244,5256.028,713.272,5255.93,713.3Zm-4.4-24.757h-12.684a1.341,1.341,0,0,0-1.46,1.449q0,10.157,0,20.314a1.342,1.342,0,0,0,1.457,1.453h16.59a1.345,1.345,0,0,0,1.471-1.464q0-8.09,0-16.179v-.292h-3.418a1.809,1.809,0,0,1-1.956-1.951c0-1.01,0-2.02,0-3.03Zm1.606,1.1-.066.046c0,.435-.011.871,0,1.306.013.4.052.807.08,1.211.4.025.792.06,1.188.071.458.012.917,0,1.293,0Z",
    fill: "#2f6bc1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5340.009,924.984q2.684,0,5.366,0a.768.768,0,0,1,.749,1.106.757.757,0,0,1-.729.434h-10.732a.774.774,0,0,1-.849-.709.763.763,0,0,1,.8-.83c1.207,0,2.413,0,3.62,0Z",
    transform: "translate(-92.94 -225.76)",
    fill: "#2f6bc1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5339.395,1044.988q2.452,0,4.9,0a.772.772,0,1,1-.01,1.54c-1,0-2,0-3,0q-3.376,0-6.753,0a.811.811,0,0,1-.717-.322.729.729,0,0,1-.062-.8.748.748,0,0,1,.711-.42h4.93Z",
    transform: "translate(-92.798 -339.6)",
    fill: "#2f6bc1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5338.878,986.532c-1.463,0-2.926,0-4.39,0a.771.771,0,1,1,.013-1.54q1.258,0,2.516,0,3.106,0,6.212,0a.768.768,0,0,1,.761,1.1.782.782,0,0,1-.774.444Q5341.047,986.529,5338.878,986.532Z",
    transform: "translate(-92.809 -282.686)",
    fill: "#2f6bc1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/report-icon.5f8c4c3b496eb7f510affa4e351c5cbd.svg";
export { ForwardRef as ReactComponent };